import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { APPOINTMENT_STATUS, REFERRAL } from '_constants';
import CallNow from './CallNow';
import PendingAppointmentOutcome from './PendingAppointmentOutcome';
import PendingAppointmentStatus from './PendingAppointmentStatus';
import AppointmentComplete from './AppointmentComplete';

const ReferralStatus = ({ ...props }) => {
  const loadContent = () => {
    // TODO replace appointmentStatus & defaultProps with props passed from parent

    const appointmentStatus = _.get(props, 'activeAppointment.eventStatus.id', null);

    let component = null;

    switch (appointmentStatus) {
      case APPOINTMENT_STATUS.ACCEPTED.id: case APPOINTMENT_STATUS.LEFT_MESSAGE.id: case APPOINTMENT_STATUS.COULDNT_REACH.id:
        component = <CallNow {...props} />;
        break;
      case APPOINTMENT_STATUS.MADE_CONTACT.id:
        component = <PendingAppointmentStatus {...props} />;
        break;

        // case APPOINTMENT_STATUS.CONFIRMED.id:
        //   component = <PendingAppointmentOutcome {...props} />;
        //   break;

      default:
        component = <AppointmentComplete {...props} />;
        break;
    }

    if (props.currentDetailCard) {
      switch (props.currentDetailCard) {
        case REFERRAL.CALL_NOW:
          component = <CallNow {...props} />;
          break;
        case REFERRAL.PENDING_APPOINTMENT_STATUS:
          component = <PendingAppointmentStatus {...props} />;
          break;
        case REFERRAL.PENDING_APPOINTMENT_OUTCOME:
          component = <PendingAppointmentOutcome {...props} />;
          break;
        default:
          component = <AppointmentComplete {...props} />;
          break;
      }
    }

    return component;
  };

  return (
    <React.Fragment>
      {loadContent()}
    </React.Fragment>
  );
};

ReferralStatus.propTypes = {
  activeAppointment: PropTypes.object,
  activeOpportunity: PropTypes.object,
  currentDetailCard: PropTypes.string,
  updateAppointmentStatus: PropTypes.func.isRequired
};

export default ReferralStatus;
